<style lang="less" scoped>
  .sender-info-cover {
    display: flex;

    .status-cover {
      width: 80px;
      height: 80px;
    }
    .sender-info {
      flex: 1;
      padding-left: 20px;
      .sender-name {
        font-size: 24px;
        margin-bottom: 9px;
      }
      .sender-info-detail {
        width: 100%;
        display: flex;
        font-size: 16px;
        color: #8492a6;
        > div {
          width: 50%;
        }
        .sender-info-title {
          margin-right: 10px;
        }
      }
    }
  }

  @media screen and (max-width: 560px) {
    .sender-info-cover {
      flex-direction: column;
      .status-cover {
        margin-bottom: 16px;
        height: auto;

        .order-status {
          padding: 5px 0;
        }
      }
      .sender-info {
        padding: 0;

        .sender-info-detail {
          flex-direction: column;
        }
      }
    }
  }
</style>

<template lang="pug">
  .sender-info-cover
    .status-cover
      status-component(:status="order.status")
    .sender-info
      h2.sender-name {{order.name}}
      .sender-info-detail
        div
          .date
            strong.sender-info-title 날짜
            span {{order.created | date}}
          .tele
            strong.sender-info-title 전화
            span {{order.phoneNumber}}
          .delivery(v-if="order.invoiceNumber")
            strong.sender-info-title 배송
            span 한의사랑택배 ({{order.invoiceNumber}})
        div
          .address
            strong.sender-info-title 주소
            span {{order.address}}
          .cost
            strong.sender-info-title 금액
            span {{order.totalPrice | price}}원 (배송료 {{order.deliveryFee.toLocaleString()}}원 포함)
</template>

<script>
import statusComponent from '@/components/order_status';
import moment from 'moment';

moment.locale('ko');

export default {
  props: ['order'],
  components: {
    statusComponent,
  },
  data() {
    return {
      status: 1,
    };
  },
  filters: {
    price(value) {
      if (typeof value === 'number') {
        return value.toLocaleString();
      }
      return value;
    },
    date(value) {
      return moment(value).format('LL');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile.vue